import "../plugins/turn.js";
import "../plugins/zoom.js";
import LazyLoad from "vanilla-lazyload";

const templateAbout = {
  init: function () {
    this.video();
    this.timeline.init();
    this.product();
  },

  video: function () {
    // On click load video and play it
    $(".video-play").on("click", function () {
      $(this).find(".video-play__btn").fadeOut(250);
      var video_dom = $(".video-wrap__video");
      LazyLoad.load(video_dom[0]);
      setTimeout(function () {
        video_dom.addClass("video-wrap__video--active");
        video_dom[0].play();
      }, 250);
    });
  },

  timeline: {
    prev_icon:
      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10" fill="#242032"><path d="M6,0V4H16V6H6v4L0,4.94Z"/></svg>',
    next_icon:
      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10" fill="#242032"><path d="M6,0V4H16V6H6v4L0,4.94Z" transform="translate(16 10) rotate(180)"/></svg>',
    el: $(".timeline-slider"),

    options: {},

    init: function () {
      this.options = {
        arrows: true,
        prevArrow:
          '<button class="slick-arrow slick-prev" aria-label="prev"><span class="slick-arrow__inner">' +
          this.prev_icon +
          this.prev_icon +
          "</span></button>",
        nextArrow:
          '<button class="slick-arrow slick-next" aria-label="next"><span class="slick-arrow__inner">' +
          this.next_icon +
          this.next_icon +
          "</span></button>",
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        swipeToSlide: true,
        rows: 0,

        responsive: [
          {
            breakpoint: 1600,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      };
      this.construct();
      this.visual();
    },

    construct: function () {
      // Slider last item opacity on init
      this.el.on("init", function (event, slick) {
        var index = templateAbout.timeline.get_index();
        templateAbout.timeline.el
          .find('.timeline-item[data-slick-index="' + index + '"]')
          .addClass("timeline-item--faded");
      });

      // Slick
      this.el.slick(this.options);
    },

    visual: function () {
      // Slider last item opacity on change
      this.el.on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
          var index = nextSlide + templateAbout.timeline.get_index();
          console.log(index);
          templateAbout.timeline.el
            .find('.timeline-item[data-slick-index="' + index + '"]')
            .addClass("timeline-item--faded")
            .siblings()
            .removeClass("timeline-item--faded");
        }
      );
    },

    get_index: function () {
      var win_width = $(window).width();
      var index = this.options.slidesToShow;

      this.options.responsive.map(function (size) {
        if (win_width < size.breakpoint) {
          index = size.settings.slidesToShow;
        }
      });

      return index - 1;
    },
  },

  product: function () {
    turnObj.init();
  },
};

const turnObj = {
  magazine: $(".magazine"),
  book: $(".magazine__book"),

  init: function () {
    this.default();
  },

  default: function () {
    var total_pages = turnObj.book.find(".flipbook__book__page").length;
    // Turn.js
    turnObj.book.turn({
      page: 2,
      width: 1136,
      height: 734,
      autoCenter: true,
      acceleration: true,
    });

    // Disable first and last page
    turnObj.book.bind("turning", function (event, page) {
      if (page == 1 || page == total_pages) {
        event.preventDefault();
      }
    });
    turnObj.book.bind("start", function (event, pageObject) {
      if (pageObject.page == 1 || pageObject.page == total_pages) {
        event.preventDefault();
      }
    });

    // Zoom.js
    turnObj.magazine.zoom({
      flipbook: $(turnObj.book),
      // max: 1.25,
      duration: 250,
    });

    // Binds the double tap event to the zoom function
    turnObj.magazine.bind("zoom.doubleTap", turnObj.zoom_to);

    // Calls the resize function when the window changes, useful when viewing on tablet or mobile phones
    $(window)
      .on("resize", function () {
        turnObj.resize_viewport();
      })
      .bind("orientationchange", function () {
        turnObj.resize_viewport();
      });

    // Must be called initially to setup the size
    turnObj.resize_viewport();

    // Prev
    $(".magazine__nav__prev").on("click", function () {
      turnObj.book.turn("previous");
    });

    // Next
    $(".magazine__nav__next").on("click", function () {
      turnObj.book.turn("next");
    });
  },

  resize_viewport: function () {
    var width = $(".magazine-wrap").width();
    var height = width / 2;

    turnObj.magazine.css({
      width: width,
      height: height,
    });

    turnObj.magazine.zoom("resize");

    turnObj.book.turn("size", width, height);
  },

  zoom_to: function (event) {
    setTimeout(function () {
      if (turnObj.magazine.data().regionClicked) {
        turnObj.magazine.data().regionClicked = false;
      } else {
        if (turnObj.magazine.zoom("value") == 1) {
          turnObj.magazine.zoom("zoomIn", event);
        } else {
          turnObj.magazine.zoom("zoomOut");
        }
      }
    }, 1);
  },
};

export default templateAbout;
